import {
  BaseQueryApi,
  QueryReturnValue,
} from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { MaybePromise } from '@reduxjs/toolkit/dist/query/tsHelpers';
import {
  // CreateSavedSearchApiArg,
  // CreateSavedSearchApiResponse,
  // DeleteSavedSearchApiArg,
  // DeleteSavedSearchApiResponse,
  // ReadSavedSearchApiArg,
  // ReadSavedSearchApiResponse,
  // ReadSavedSearchesApiArg,
  // ReadSavedSearchesApiResponse,
  ReadSearchApiArg,
  ReadSearchApiResponse,
  // ReadSearchEnrichedFiltersApiArg,
  // ReadSearchEnrichedFiltersApiResponse,
  SearchScope,
  // UpdateSavedSearchApiArg,
  // UpdateSavedSearchApiResponse,
} from 'lib-search-types';
import {
  EndpointExtraOptions,
  EndpointOptions,
  QueryError,
} from 'lib-shared-auth';

import { api } from 'app/app.api';

export const krakenApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // ============================================================================
    // Generic loosely typed search endpoints
    // ============================================================================
    readSearch: builder.query(getReadSearchEndpointDefinition()),

    // ============================================================================
    // Scope-specific strictly typed search endpoints
    // ============================================================================
    readSearchCompanies: builder.query(
      getReadSearchEndpointDefinition('companies'),
    ),
    // readSearchConversations: builder.query(
    //   getReadSearchEndpointDefinition('conversations'),
    // ),
    readSearchQueues: builder.query(getReadSearchEndpointDefinition('queues')),
    readSearchTags: builder.query(getReadSearchEndpointDefinition('tags')),
    readSearchTeams: builder.query(getReadSearchEndpointDefinition('teams')),
    readSearchUsers: builder.query(getReadSearchEndpointDefinition('users')),

    // ============================================================================
    // Enriched search endpoints
    // ============================================================================
    // readSearchConversationsEnriched: builder.query(
    //   getReadSearchEndpointDefinition('conversations', true),
    // ),
    readSearchQueuesEnriched: builder.query(
      getReadSearchEndpointDefinition('queues', true),
    ),
    readSearchTeamsEnriched: builder.query(
      getReadSearchEndpointDefinition('teams', true),
    ),
    readSearchUsersEnriched: builder.query(
      getReadSearchEndpointDefinition('users', true),
    ),

    // ============================================================================
    // Saved search endpoints
    // ============================================================================
    // readSavedSearches: builder.query<
    //   ReadSavedSearchesApiResponse,
    //   ReadSavedSearchesApiArg
    // >({
    //   query: () => ({
    //     version: 4,
    //     path: 'search/saved-searches/search',
    //     method: 'POST',
    //   }),
    // }),
    // readSavedSearch: builder.query<
    //   ReadSavedSearchApiResponse,
    //   ReadSavedSearchApiArg
    // >({
    //   query: ({ id }) => ({
    //     version: 4,
    //     path: `search/saved-searches/${id}`,
    //   }),
    // }),
    // createSavedSearch: builder.mutation<
    //   CreateSavedSearchApiResponse,
    //   CreateSavedSearchApiArg
    // >({
    //   query: () => ({
    //     version: 4,
    //     path: 'search/saved-searches',
    //     method: 'POST',
    //   }),
    //   async onQueryStarted(_arg) {
    //     /** TODO */
    //   },
    // }),
    // updateSavedSearch: builder.mutation<
    //   UpdateSavedSearchApiResponse,
    //   UpdateSavedSearchApiArg
    // >({
    //   query: ({ id, ...body }) => ({
    //     version: 4,
    //     path: `search/saved-searches/${id}`,
    //     method: 'PATCH',
    //     body,
    //   }),
    //   async onQueryStarted(_arg) {
    //     /** TODO */
    //   },
    // }),
    // deleteSavedSearch: builder.mutation<
    //   DeleteSavedSearchApiResponse,
    //   DeleteSavedSearchApiArg
    // >({
    //   query: ({ id }) => ({
    //     version: 4,
    //     path: `search/saved-searches/${id}`,
    //     method: 'DELETE',
    //   }),
    //   async onQueryStarted(_arg) {
    //     /** TODO */
    //   },
    // }),

    // ============================================================================
    // Other search-related endpoints
    // ============================================================================
    // readSearchEnrichedFilters: builder.query<
    //   ReadSearchEnrichedFiltersApiResponse,
    //   ReadSearchEnrichedFiltersApiArg
    // >({
    //   query: (body) => {
    //     return {
    //       version: 4,
    //       path: 'search/enrich',
    //       method: 'POST',
    //       body,
    //     };
    //   },
    // }),
  }),
});

/**
 * Returns the endpoint definition for reading search results.
 *
 * @param scope - The search scope for which to create the endpoint definition.
 *   If not provided, the scope will be inferred from the request body.
 * @param enriched - Whether to return enriched resources with expanded
 *   relations.
 */
function getReadSearchEndpointDefinition<
  TScope extends SearchScope | undefined = undefined,
  TEnriched extends boolean = false,
>(scope?: TScope, _enriched?: TEnriched) {
  return {
    async queryFn(
      _arg: [TScope] extends [SearchScope]
        ? Omit<ReadSearchApiArg<TScope, TEnriched>, 'scope'> & {
            scope?: TScope;
          }
        : ReadSearchApiArg<SearchScope, TEnriched>,
      _api: BaseQueryApi,
      _extraOptions: EndpointExtraOptions,
      baseQuery: (
        arg: EndpointOptions | string,
      ) => MaybePromise<
        QueryReturnValue<unknown, QueryError, Record<string, unknown>>
      >,
    ) {
      const arg = _arg as ReadSearchApiArg;

      const response = await baseQuery({
        version: 4,
        path: `search/${scope ?? arg.scope}`,
        method: 'POST',
        body: {
          ...arg,
          filters: arg.filters ?? {
            strategy: 'all',
            filters: [],
          },
        },
      });

      if (response.error) {
        return { error: response.error };
      }

      return {
        data: response.data as ReadSearchApiResponse<
          [TScope] extends [SearchScope] ? TScope : SearchScope,
          TEnriched
        >,
      };
    },
  };
}
